export default __webpack_public_path__ + "static/media/Highlord's Pendant of Wisdom.eccfc16f.jpg";